
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comparisons/wipster-pricing",
      function () {
        return require("private-next-pages/comparisons/wipster-pricing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comparisons/wipster-pricing"])
      });
    }
  